export const GET_CUSTOMERS_INIT = "GET_CUSTOMERS_INIT";
export const GET_CUSTOMERS_SUCCESS = "GET_CUSTOMERS_SUCCESS";
export const GET_CUSTOMERS_FAIL = "GET_CUSTOMERS_FAIL";

export const CREATE_CUSTOMERS_INIT = "CREATE_CUSTOMERS_INIT";
export const CREATE_CUSTOMERS_SUCCESS = "CREATE_CUSTOMERS_SUCCESS";
export const CREATE_CUSTOMERS_FAIL = "CREATE_CUSTOMERS_FAIL";

export const UPDATE_CUSTOMERS_INIT = "UPDATE_CUSTOMERS_INIT";
export const UPDATE_CUSTOMERS_SUCCESS = "UPDATE_CUSTOMERS_SUCCESS";
export const UPDATE_CUSTOMERS_FAIL = "UPDATE_CUSTOMERS_FAIL";

export const DELETE_CUSTOMERS_INIT = "DELETE_CUSTOMERS_INIT";
export const DELETE_CUSTOMERS_SUCCESS = "DELETE_CUSTOMERS_SUCCESS";
export const DELETE_CUSTOMERS_FAIL = "DELETE_CUSTOMERS_FAIL";

export const GET_CUSTOMER_DETAIL_V2_INIT = "GET_CUSTOMER_DETAIL_V2_INIT";
export const GET_CUSTOMER_DETAIL_V2_SUCCESS = "GET_CUSTOMER_DETAIL_V2_SUCCESS";
export const GET_CUSTOMER_DETAIL_V2_FAIL = "GET_CUSTOMER_DETAIL_V2_FAIL";
export const CLEAR_DETAIL_V2_DATA = "CLEAR_DETAIL_V2_DATA";

export const GET_BULK_CUSTOMER_DETAIL_V2_INIT =
  "GET_BULK_CUSTOMER_DETAIL_V2_INIT";
export const GET_BULK_CUSTOMER_DETAIL_V2_SUCCESS =
  "GET_BULK_CUSTOMER_DETAIL_V2_SUCCESS";
export const GET_BULK_CUSTOMER_DETAIL_V2_FAIL =
  "GET_BULK_CUSTOMER_DETAIL_V2_FAIL";
export const CLEAR_BULK_CUSTOMER_DETAIL_V2_DATA = "CLEAR_BULK_DETAIL_V2_DATA";

export const GET_PRODUCTS_INIT = "GET_PRODUCTS_INIT";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL";

export const GET_GLOBAL_PRODUCTS_DETAILS_INIT =
  "GET_GLOBAL_PRODUCTS_DETAILS_INIT";
export const GET_GLOBAL_PRODUCTS_DETAILS_SUCCESS =
  "GET_GLOBAL_PRODUCTS_DETAILS_SUCCESS";
export const GET_GLOBAL_PRODUCTS_DETAILS_FAIL =
  "GET_GLOBAL_PRODUCTS_DETAILS_FAIL";
export const CLEAR_GLOBAL_PRODUCT_DETAILS = "CLEAR_GLOBAL_PRODUCT_DETAILS";

export const CREATE_GLOBAL_PRODUCT_INIT = "CREATE_GLOBAL_PRODUCT_INIT";
export const CREATE_GLOBAL_PRODUCT_SUCCESS = "CREATE_GLOBAL_PRODUCT_SUCCESS";
export const CREATE_GLOBAL_PRODUCT_FAIL = "CREATE_GLOBAL_PRODUCT_FAIL";

export const UPDATE_GLOBAL_PRODUCT_INIT = "UPDATE_GLOBAL_PRODUCT_INIT";
export const UPDATE_GLOBAL_PRODUCT_SUCCESS = "UPDATE_GLOBAL_PRODUCT_SUCCESS";
export const UPDATE_GLOBAL_PRODUCT_FAIL = "UPDATE_GLOBAL_PRODUCT_FAIL";

export const GET_PRODUCT_TYPE_INIT = "GET_PRODUCT_TYPE_INIT";
export const GET_PRODUCT_TYPE_SUCCESS = "GET_PRODUCT_TYPE_SUCCESS";
export const GET_PRODUCT_TYPE_FAIL = "GET_PRODUCT_TYPE_FAIL";

export const GET_PRODUCT_BRANDS_INIT = "GET_PRODUCT_BRANDS_INIT";
export const GET_PRODUCT_BRANDS_SUCCESS = "GET_PRODUCT_BRANDS_SUCCESS";
export const GET_PRODUCT_BRANDS_FAIL = "GET_PRODUCT_BRANDS_FAIL";

export const GET_PRODUCT_UOM_INIT = "GET_PRODUCT_UOM_INIT";
export const GET_PRODUCT_UOM_SUCCESS = "GET_PRODUCT_UOM_SUCCESS";
export const GET_PRODUCT_UOM_FAIL = "GET_PRODUCT_UOM_FAIL";

export const GET_CATEGORIES_INIT = "GET_CATEGORIES_INIT";
export const GET_CATEGORIES_SUCCESS = "GET_CATEGORIES_SUCCESS";
export const GET_CATEGORIES_FAIL = "GET_CATEGORIES_FAIL";

export const LOGIN_INIT = "LOGIN_INIT";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const BULK_UPLOAD_INIT = "BULK_UPLOAD_INIT";
export const BULK_UPLOAD_SUCCESS = "BULK_UPLOAD_SUCCESS";
export const BULK_UPLOAD_FAIL = "BULK_UPLOAD_FAIL";

export const INVENTORY_UPLOAD_INIT = "INVENTORY_UPLOAD_INIT";
export const INVENTORY_UPLOAD_SUCCESS = "INVENTORY_UPLOAD_SUCCESS";
export const INVENTORY_UPLOAD_FAIL = "INVENTORY_UPLOAD_FAIL";

export const NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_INIT =
  "NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_INIT";
export const NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_SUCCESS =
  "NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_SUCCESS";
export const NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_FAIL =
  "NEW_CITY_LEVEL_PRODUCT_PRICE_UPLOAD_FAIL";

export const GET_CATEGORIES_LIST_INIT = "GET_CATEGORIES_LIST_INIT";
export const GET_CATEGORIES_LIST_SUCCESS = "GET_CATEGORIES_LIST_SUCCESS";
export const GET_CATEGORIES_LIST_FAIL = "GET_CATEGORIES_LIST_FAIL";

export const UPDATE_CITY_LEVEL_CATEGORY_INIT =
  "UPDATE_CITY_LEVEL_CATEGORY_INIT";
export const UPDATE_CITY_LEVEL_CATEGORY_SUCCESS =
  "UPDATE_CITY_LEVEL_CATEGORY_SUCCESS";
export const UPDATE_CITY_LEVEL_CATEGORY_FAIL =
  "UPDATE_CITY_LEVEL_CATEGORY_FAIL";

export const CREATE_ORDER_INIT = "CREATE_ORDER_INIT";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";

export const FETCH_CREDIT_USER_INIT= "FETCH_CREDIT_USER_INIT";
export const FETCH_CREDIT_USER_SUCCESS = "FETCH_CREDIT_USER_SUCCESS";
export const FETCH_CREDIT_USER_FAIL = "FETCH_CREDIT_USER_FAIL";

export const GET_ORDERS_INIT = "GET_ORDERS_INIT";
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS";
export const GET_ORDERS_FAIL = "GET_ORDERS_FAIL";

export const GET_ORDERS_DETAILS_INIT = "GET_ORDERS_DETAILS_INIT";
export const GET_ORDERS_DETAILS_SUCCESS = "GET_ORDERS_DETAILS_SUCCESS";
export const GET_ORDERS_DETAILS_FAIL = "GET_ORDERS_DETAILS_FAIL";
export const CLEAR_ORDER_DETAILS = "CLEAR_ORDER_DETAILS";

export const UPDATE_ORDER_INIT = "UPDATE_ORDER_INIT";
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS";
export const UPDATE_ORDER_FAIL = "UPDATE_ORDER_FAIL";

export const UPDATE_ORDER_STATUS_INIT = "UPDATE_ORDER_STATUS_INIT";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
export const UPDATE_ORDER_STATUS_FAIL = "UPDATE_ORDER_STATUS_FAIL";

export const GET_ORDER_PRICE_BREAKDOWN_INIT = "GET_ORDER_PRICE_BREAKDOWN_INIT";
export const GET_ORDER_PRICE_BREAKDOWN_SUCCESS =
  "GET_ORDER_PRICE_BREAKDOWN_SUCCESS";
export const GET_ORDER_PRICE_BREAKDOWN_FAIL = "GET_ORDER_PRICE_BREAKDOWN_FAIL";

export const UPLOAD_PRODUCT_IMAGE_INIT = "UPLOAD_PRODUCT_IMAGE_INIT";
export const UPLOAD_PRODUCT_IMAGE_SUCCESS = "UPLOAD_PRODUCT_IMAGE_SUCCESS";
export const UPLOAD_PRODUCT_IMAGE_FAIL = "UPLOAD_PRODUCT_IMAGE_FAIL";

export const REORDER_CATEGORY_PRODUCTS_FOR_CITY_INIT =
  "REORDER_CATEGORY_PRODUCTS_FOR_CITY_INIT";
export const REORDER_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS =
  "REORDER_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS";
export const REORDER_CATEGORY_PRODUCTS_FOR_CITY_FAIL =
  "REORDER_CATEGORY_PRODUCTS_FOR_CITY_FAIL";

export const GET_ACCESS_CONTROL_USERS_INIT = "GET_ACCESS_CONTROL_USERS_INIT";
export const GET_ACCESS_CONTROL_USERS_SUCCESS =
  "GET_ACCESS_CONTROL_USERS_SUCCESS";
export const GET_ACCESS_CONTROL_USERS_FAIL = "GET_ACCESS_CONTROL_USERS_FAIL";

export const CREATE_ACCESS_CONTROL_USERS_INIT =
  "CREATE_ACCESS_CONTROL_USERS_INIT";
export const CREATE_ACCESS_CONTROL_USERS_SUCCESS =
  "CREATE_ACCESS_CONTROL_USERS_SUCCESS";
export const CREATE_ACCESS_CONTROL_USERS_FAIL =
  "CREATE_ACCESS_CONTROL_USERS_FAIL";

export const UPDATE_ACCESS_CONTROL_USERS_INIT =
  "UPDATE_ACCESS_CONTROL_USERS_INIT";
export const UPDATE_ACCESS_CONTROL_USERS_SUCCESS =
  "UPDATE_ACCESS_CONTROL_USERS_SUCCESS";
export const UPDATE_ACCESS_CONTROL_USERS_FAIL =
  "UPDATE_ACCESS_CONTROL_USERS_FAIL";

export const DELETE_ACCESS_CONTROL_USERS_INIT =
  "DELETE_ACCESS_CONTROL_USERS_INIT";
export const DELETE_ACCESS_CONTROL_USERS_SUCCESS =
  "DELETE_ACCESS_CONTROL_USERS_SUCCESS";
export const DELETE_ACCESS_CONTROL_USERS_FAIL =
  "DELETE_ACCESS_CONTROL_USERS_FAIL";

export const GET_ACCESS_CONTROL_USER_DETAIL_V2_INIT =
  "GET_ACCESS_CONTROL_USER_DETAIL_V2_INIT";
export const GET_ACCESS_CONTROL_USER_DETAIL_V2_SUCCESS =
  "GET_ACCESS_CONTROL_USER_DETAIL_V2_SUCCESS";
export const GET_ACCESS_CONTROL_USER_DETAIL_V2_FAIL =
  "GET_ACCESS_CONTROL_USER_DETAIL_V2_FAIL";

export const GET_ALL_CLIENT_ROLES_INIT = "GET_ALL_CLIENT_ROLES_INIT";
export const GET_ALL_CLIENT_ROLES_SUCCESS = "GET_ALL_CLIENT_ROLES_SUCCESS";
export const GET_ALL_CLIENT_ROLES_FAIL = "GET_ALL_CLIENT_ROLES_FAIL";

export const GET_PROMOS_FOR_ORDER_INIT = "GET_PROMOS_FOR_ORDER_INIT";
export const GET_PROMOS_FOR_ORDER_SUCCESS = "GET_PROMOS_FOR_ORDER_SUCCESS";
export const GET_PROMOS_FOR_ORDER_FAIL = "GET_PROMOS_FOR_ORDER_FAIL";

export const GET_AGENT_MANAGEMENT_USERS_INIT =
  "GET_AGENT_MANAGEMENT_USERS_INIT";
export const GET_AGENT_MANAGEMENT_USERS_SUCCESS =
  "GET_AGENT_MANAGEMENT_USERS_SUCCESS";
export const GET_AGENT_MANAGEMENT_USERS_FAIL =
  "GET_AGENT_MANAGEMENT_USERS_FAIL";

export const CREATE_AGENT_MANAGEMENT_USERS_INIT =
  "CREATE_AGENT_MANAGEMENT_USERS_INIT";
export const CREATE_AGENT_MANAGEMENT_USERS_SUCCESS =
  "CREATE_AGENT_MANAGEMENT_USERS_SUCCESS";
export const CREATE_AGENT_MANAGEMENT_USERS_FAIL =
  "CREATE_AGENT_MANAGEMENT_USERS_FAIL";

export const UPDATE_AGENT_MANAGEMENT_USERS_INIT =
  "UPDATE_AGENT_MANAGEMENT_USERS_INIT";
export const UPDATE_AGENT_MANAGEMENT_USERS_SUCCESS =
  "UPDATE_AGENT_MANAGEMENT_USERS_SUCCESS";
export const UPDATE_AGENT_MANAGEMENT_USERS_FAIL =
  "UPDATE_AGENT_MANAGEMENT_USERS_FAIL";

export const DELETE_AGENT_MANAGEMENT_USERS_INIT =
  "DELETE_AGENT_MANAGEMENT_USERS_INIT";
export const DELETE_AGENT_MANAGEMENT_USERS_SUCCESS =
  "DELETE_AGENT_MANAGEMENT_USERS_SUCCESS";
export const DELETE_AGENT_MANAGEMENT_USERS_FAIL =
  "DELETE_AGENT_MANAGEMENT_USERS_FAIL";

export const GET_AGENT_MANAGEMENT_USER_DETAIL_INIT =
  "GET_AGENT_MANAGEMENT_USER_DETAIL_INIT";
export const GET_AGENT_MANAGEMENT_USER_DETAIL_SUCCESS =
  "GET_AGENT_MANAGEMENT_USER_DETAIL_SUCCESS";
export const GET_AGENT_MANAGEMENT_USER_DETAIL_FAIL =
  "GET_AGENT_MANAGEMENT_USER_DETAIL_FAIL";
export const CLEAR_AGENT_MANAGEMENT_DATA = "CLEAR_AGENT_MANAGEMENT_DATA";

export const GET_WAREHOUSE_INIT = "GET_WAREHOUSE_INIT";
export const GET_WAREHOUSE_SUCCESS = "GET_WAREHOUSE_SUCCESS";
export const GET_WAREHOUSE_FAIL = "GET_WAREHOUSE_FAIL";

export const GET_DELIVERY_OPTIONS_INIT = "GET_DELIVERY_OPTIONS_INIT";
export const GET_DELIVERY_OPTIONS_SUCCESS = "GET_DELIVERY_OPTIONS_SUCCESS";
export const GET_DELIVERY_OPTIONS_FAIL = "GET_DELIVERY_OPTIONS_FAIL";

export const GET_PRODUCT_INVENTORY_INIT = "GET_PRODUCT_INVENTORY_INIT";
export const GET_PRODUCT_INVENTORY_SUCCESS = "GET_PRODUCT_INVENTORY_SUCCESS";
export const GET_PRODUCT_INVENTORY_FAIL = "GET_PRODUCT_INVENTORY_FAIL";

export const UPDATE_PRODUCT_INVENTORY_INIT = "UPDATE_PRODUCT_INVENTORY_INIT";
export const UPDATE_PRODUCT_INVENTORY_SUCCESS =
  "UPDATE_PRODUCT_INVENTORY_SUCCESS";
export const UPDATE_PRODUCT_INVENTORY_FAIL = "UPDATE_PRODUCT_INVENTORY_FAIL";

export const GET_AGENT_TITLE_INIT = "GET_AGENT_TITLE_INIT";
export const GET_AGENT_TITLE_SUCCESS = "GET_AGENT_TITLE_SUCCESS";
export const GET_AGENT_TITLE_FAIL = "GET_AGENT_TITLE_FAIL";

export const GET_AGENT_TEAM_INIT = "GET_AGENT_TEAM_INIT";
export const GET_AGENT_TEAM_SUCCESS = "GET_AGENT_TEAM_SUCCESS";
export const GET_AGENT_TEAM_FAIL = "GET_AGENT_TEAM_FAIL";

export const GET_BRANDS_INIT = "GET_BRANDS_INIT";
export const GET_BRANDS_SUCCESS = "GET_BRANDS_SUCCESS";
export const GET_BRANDS_FAIL = "GET_BRANDS_FAIL";

export const GET_ALL_AGENT_TEAM_ZONES_INIT = "GET_ALL_AGENT_TEAM_ZONES_INIT";
export const GET_ALL_AGENT_TEAM_ZONES_SUCCESS =
  "GET_ALL_AGENT_TEAM_ZONES_SUCCESS";
export const GET_ALL_AGENT_TEAM_ZONES_FAIL = "GET_ALL_AGENT_TEAM_ZONES_FAIL";

export const GET_ODOO_TAX_INIT = "GET_ODOO_TAX_INIT";
export const GET_ODOO_TAX_SUCCESS = "GET_ODOO_TAX_SUCCESS";
export const GET_ODOO_TAX_FAIL = "GET_ODOO_TAX_FAIL";

export const ASSIGN_TOUR_INIT = "ASSIGN_TOUR_INIT";
export const ASSIGN_TOUR_SUCCESS = "ASSIGN_TOUR_SUCCESS";
export const ASSIGN_TOUR_FAIL = "ASSIGN_TOUR_FAIL";

export const UPLOAD_TOUR_CSV_INIT = "UPLOAD_TOUR_CSV_INIT";
export const UPLOAD_TOUR_CSV_SUCCESS = "UPLOAD_TOUR_CSV_SUCCESS";
export const UPLOAD_TOUR_CSV_FAIL = "UPLOAD_TOUR_CSV_FAIL";

export const UPLOAD_3PL_PLAN_TOURS_CSV_INIT = "UPLOAD_3PL_PLAN_TOURS_CSV_INIT";
export const UPLOAD_3PL_PLAN_TOURS_CSV_SUCCESS =
  "UPLOAD_3PL_PLAN_TOURS_CSV_SUCCESS";
export const UPLOAD_3PL_PLAN_TOURS_CSV_FAIL = "UPLOAD_3PL_PLAN_TOURS_CSV_FAIL";

export const DOWNLOAD_LOCUS_PLAN_CSV_INIT = "DOWNLOAD_LOCUS_PLAN_CSV_INIT";
export const DOWNLOAD_LOCUS_PLAN_CSV_SUCCESS =
  "DOWNLOAD_LOCUS_PLAN_CSV_SUCCESS";
export const DOWNLOAD_LOCUS_PLAN_CSV_FAIL = "DOWNLOAD_LOCUS_PLAN_CSV_FAIL";

export const DOWNLOAD_PLAN_OUTPUT_CSV_INIT = "DOWNLOAD_PLAN_OUTPUT_CSV_INIT";
export const DOWNLOAD_PLAN_OUTPUT_CSV_SUCCESS =
  "DOWNLOAD_PLAN_OUTPUT_CSV_SUCCESS";
export const DOWNLOAD_PLAN_OUTPUT_CSV_FAIL = "DOWNLOAD_PLAN_OUTPUT_CSV_FAIL";

export const ASSIGN_PLAN_INIT = "ASSIGN_PLAN_INIT";
export const ASSIGN_PLAN_SUCCESS = "ASSIGN_PLAN_SUCCESS";
export const ASSIGN_PLAN_FAIL = "ASSIGN_PLAN_FAIL";

export const GET_BANNERS_INIT = "GET_BANNERS_INIT";
export const GET_BANNERS_SUCCESS = "GET_BANNERS_SUCCESS";
export const GET_BANNERS_FAIL = "GET_BANNERS_FAIL";

export const UPDATE_BANNER_INIT = "UPDATE_BANNER_INIT";
export const UPDATE_BANNER_SUCCESS = "UPDATE_BANNER_SUCCESS";
export const UPDATE_BANNER_FAIL = "UPDATE_BANNER_FAIL";

export const UPDATE_BANNER_AND_PRODUCT_INIT = "UPDATE_BANNER_AND_PRODUCT_INIT";
export const UPDATE_BANNER_AND_PRODUCT_SUCCESS =
  "UPDATE_BANNER_AND_PRODUCT_SUCCESS";
export const UPDATE_BANNER_AND_PRODUCT_FAIL = "UPDATE_BANNER_AND_PRODUCT_FAIL";

export const UPDATE_BANNER_SEQUENCE_INIT = "UPDATE_BANNER_SEQUENCE_INIT";
export const UPDATE_BANNER_SEQUENCE_SUCCESS = "UPDATE_BANNER_SEQUENCE_SUCCESS";
export const UPDATE_BANNER_SEQUENCE_FAIL = "UPDATE_BANNER_SEQUENCE_FAIL";

export const UPDATE_PRODUCT_CITY_LEVEL_INIT = "UPDATE_PRODUCT_CITY_LEVEL_INIT";
export const UPDATE_PRODUCT_CITY_LEVEL_SUCCESS =
  "UPDATE_PRODUCT_CITY_LEVEL_SUCCESS";
export const UPDATE_PRODUCT_CITY_LEVEL_FAIL = "UPDATE_PRODUCT_CITY_LEVEL_FAIL";

export const GET_CITIES_INIT = "GET_CITIES_INIT";
export const GET_CITIES_SUCCESS = "GET_CITIES_SUCCESS";
export const GET_CITIES_FAIL = "GET_CITIES_FAIL";

export const CREATE_PRODUCT_CITY_LEVEL_INIT = "CREATE_PRODUCT_CITY_LEVEL_INIT";
export const CREATE_PRODUCT_CITY_LEVEL_SUCCESS =
  "CREATE_PRODUCT_CITY_LEVEL_SUCCESS";
export const CREATE_PRODUCT_CITY_LEVEL_FAIL = "CREATE_PRODUCT_CITY_LEVEL_FAIL";

export const GET_PRODUCTS_CITY_LEVEL_INIT = "GET_PRODUCTS_CITY_LEVEL_INIT";
export const GET_PRODUCTS_CITY_LEVEL_SUCCESS =
  "GET_PRODUCTS_CITY_LEVEL_SUCCESS";
export const GET_PRODUCTS_CITY_LEVEL_FAIL = "GET_PRODUCTS_CITY_LEVEL_FAIL";

export const GET_PRODUCTS_CITY_LEVEL_DETAILS_INIT =
  "GET_PRODUCTS_CITY_LEVEL_DETAILS_INIT";
export const GET_PRODUCTS_CITY_LEVEL_DETAILS_SUCCESS =
  "GET_PRODUCTS_CITY_LEVEL_DETAILS_SUCCESS";
export const GET_PRODUCTS_CITY_LEVEL_DETAILS_FAIL =
  "GET_PRODUCTS_CITY_LEVEL_DETAILS_FAIL";

export const GET_PRODUCT_CITY_LEVEL_TYPE_INIT =
  "GET_PRODUCT_CITY_LEVEL_TYPE_INIT";
export const GET_PRODUCT_CITY_LEVEL_TYPE_SUCCESS =
  "GET_PRODUCT_CITY_LEVEL_TYPE_SUCCESS";
export const GET_PRODUCT_CITY_LEVEL_TYPE_FAIL =
  "GET_PRODUCT_CITY_LEVEL_TYPE_FAIL";

export const GET_PRODUCT_CITY_LEVEL_UOM_INIT =
  "GET_PRODUCT_CITY_LEVEL_UOM_INIT";
export const GET_PRODUCT_CITY_LEVEL_UOM_SUCCESS =
  "GET_PRODUCT_CITY_LEVEL_UOM_SUCCESS";
export const GET_PRODUCT_CITY_LEVEL_UOM_FAIL =
  "GET_PRODUCT_CITY_LEVEL_UOM_FAIL";

export const GET_PRODUCT_CITY_LEVEL_BRANDS_INIT =
  "GET_PRODUCT_CITY_LEVEL_BRANDS_INIT";
export const GET_PRODUCT_CITY_LEVEL_BRANDS_SUCCESS =
  "GET_PRODUCT_CITY_LEVEL_BRANDS_SUCCESS";
export const GET_PRODUCT_CITY_LEVEL_BRANDS_FAIL =
  "GET_PRODUCT_CITY_LEVEL_BRANDS_FAIL";

export const GET_PRODUCT_CITY_LEVEL_INVENTORY_INIT =
  "GET_PRODUCT_CITY_LEVEL_INVENTORY_INIT";
export const GET_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS =
  "GET_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS";
export const GET_PRODUCT_CITY_LEVEL_INVENTORY_FAIL =
  "GET_PRODUCT_CITY_LEVEL_INVENTORY_FAIL";

export const UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_INIT =
  "UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_INIT";
export const UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS =
  "UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_SUCCESS";
export const UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_FAIL =
  "UPDATE_PRODUCT_CITY_LEVEL_INVENTORY_FAIL";

export const CLEAR_PRODUCT_CITY_LEVEL_DETAILS =
  "CLEAR_PRODUCT_CITY_LEVEL_DETAILS";

export const CLEAR_ACCESS_CONTROL_USER_LEVEL_DETAILS =
  "CLEAR_ACCESS_CONTROL_USER_LEVEL_DETAILS";

export const GET_MFA_SESSION_INIT = "GET_MFA_SESSION_INIT";
export const GET_MFA_SESSION_SUCCESS = "GET_MFA_SESSION_SUCCESS";
export const GET_MFA_SESSION_FAIL = "GET_MFA_SESSION_FAIL";

export const VALIDATE_MFA_SESSION_INIT = "VALIDATE_MFA_SESSION_INIT";
export const VALIDATE_MFA_SESSION_SUCCESS = "VALIDATE_MFA_SESSION_SUCCESS";
export const VALIDATE_MFA_SESSION_FAIL = "VALIDATE_MFA_SESSION_FAIL";

export const MFA_FALLBACK_INIT = "MFA_FALLBACK_INIT";
export const MFA_FALLBACK_SUCCESS = "MFA_FALLBACK_SUCCESS";
export const MFA_FALLBACK_FAIL = "MFA_FALLBACK_FAIL";

export const GET_CATEGORIES_GLOBAL_LIST_INIT =
  "GET_CATEGORIES_GLOBAL_LIST_INIT";
export const GET_CATEGORIES_GLOBAL_LIST_SUCCESS =
  "GET_CATEGORIES_GLOBAL_LIST_SUCCESS";
export const GET_CATEGORIES_GLOBAL_LIST_FAIL =
  "GET_CATEGORIES_GLOBAL_LIST_FAIL";

export const FETCH_CATEGORIES_CITY_LIST_INIT = "GET_CATEGORIES_CITY_LIST_INIT";
export const FETCH_CATEGORIES_CITY_LIST_SUCCESS =
  "GET_CATEGORIES_CITY_LIST_SUCCESS";
export const FETCH_CATEGORIES_CITY_LIST_FAIL = "GET_CATEGORIES_CITY_LIST_FAIL";

export const FETCH_CATEGORY_PRODUCTS_FOR_CITY_INIT =
  "FETCH_CATEGORY_PRODUCTS_FOR_CITY_INIT";
export const FETCH_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS =
  "FETCH_CATEGORY_PRODUCTS_FOR_CITY_SUCCESS";
export const FETCH_CATEGORY_PRODUCTS_FOR_CITY_FAIL =
  "FETCH_CATEGORY_PRODUCTS_FOR_CITY_FAIL";

export const CREATE_CATEGORY_GLOBAL_INIT = "CREATE_CATEGORY_GLOBAL_INIT";
export const CREATE_CATEGORY_GLOBAL_SUCCESS = "CREATE_CATEGORY_GLOBAL_SUCCESS";
export const CREATE_CATEGORY_GLOBAL_FAIL = "CREATE_CATEGORY_GLOBAL_FAIL";

export const UPDATE_CATEGORY_GLOBAL_INIT = "UPDATE_CATEGORY_GLOBAL_INIT";
export const UPDATE_CATEGORY_GLOBAL_SUCCESS = "UPDATE_CATEGORY_GLOBAL_SUCCESS";
export const UPDATE_CATEGORY_GLOBAL_FAIL = "UPDATE_CATEGORY_GLOBAL_FAIL";

export const GET_CORE_CATEGORIES_GLOBAL_INIT =
  "GET_CORE_CATEGORIES_GLOBAL_INIT";
export const GET_CORE_CATEGORIES_GLOBAL_SUCCESS =
  "GET_CORE_CATEGORIES_GLOBAL_SUCCESS";
export const GET_CORE_CATEGORIES_GLOBAL_FAIL =
  "GET_CORE_CATEGORIES_GLOBAL_FAIL";

export const CREATE_RIDER_MANAGEMENT_USERS_INIT =
  "CREATE_RIDER_MANAGEMENT_USERS_INIT";
export const CREATE_RIDER_MANAGEMENT_USERS_SUCCESS =
  "CREATE_RIDER_MANAGEMENT_USERS_SUCCESS";
export const CREATE_RIDER_MANAGEMENT_USERS_FAIL =
  "CREATE_RIDER_MANAGEMENT_USERS_FAIL";

export const CREATE_RIDER_INIT = "CREATE_RIDER_INIT";
export const CREATE_RIDER_SUCCESS = "CREATE_RIDER_SUCCESS";
export const CREATE_RIDER_FAIL = "CREATE_RIDER_FAIL";

export const UPDATE_RIDER_MANAGEMENT_USER_INIT =
  "UPDATE_RIDER_MANAGEMENT_USER_INIT";
export const UPDATE_RIDER_MANAGEMENT_USER_SUCCESS =
  "UPDATE_RIDER_MANAGEMENT_USER_SUCCESS";
export const UPDATE_RIDER_MANAGEMENT_USER_FAIL =
  "UPDATE_RIDER_MANAGEMENT_USER_FAIL";

export const GET_RIDER_USER_DETAIL_INIT = "GET_RIDER_USER_DETAIL_INIT";
export const GET_RIDER_USER_DETAIL_SUCCESS = "GET_RIDER_USER_DETAIL_SUCCESS";
export const GET_RIDER_USER_DETAIL_FAIL = "GET_RIDER_USER_DETAIL_FAIL";

export const GET_RIDER_MANAGEMENT_LIST_INIT = "GET_RIDER_MANAGEMENT_LIST_INIT";
export const GET_RIDER_MANAGEMENT_LIST_SUCCESS =
  "GET_RIDER_MANAGEMENT_LIST_SUCCESS";
export const GET_RIDER_MANAGEMENT_LIST_FAIL = "GET_RIDER_MANAGEMENT_FAIL";

export const GET_RIDER_JOB_TYPES_INIT = "GET_RIDER_JOB_TYPES_INIT";
export const GET_RIDER_JOB_TYPES_SUCCESS = "GET_RIDER_JOB_TYPES_SUCCESS";
export const GET_RIDER_JOB_TYPES_FAIL = "GET_RIDER_JOB_TYPES_FAIL";

export const CREATE_PROMO_CITY_LEVEL_INIT = "CREATE_PROMO_CITY_LEVEL_INIT";
export const CREATE_PROMO_CITY_LEVEL_SUCCESS =
  "CREATE_PROMO_CITY_LEVEL_SUCCESS";
export const CREATE_PROMO_CITY_LEVEL_FAIL = "CREATE_PROMO_CITY_LEVEL_FAIL";

export const GET_PROMOS_CITY_LEVEL_INIT = "GET_PROMOS_CITY_LEVEL_INIT";
export const GET_PROMOS_CITY_LEVEL_SUCCESS = "GET_PROMOS_CITY_LEVEL_SUCCESS";
export const GET_PROMOS_CITY_LEVEL_FAIL = "GET_PROMOS_CITY_LEVEL_FAIL";

export const GET_ZONAL_CONFIGS_LIST_INIT = "GET_ZONAL_CONFIGS_LIST_INIT";
export const GET_ZONAL_CONFIGS_LIST_SUCCESS = "GET_ZONAL_CONFIGS_LIST_SUCCESS";
export const GET_ZONAL_CONFIGS_LIST_FAIL = "GET_ZONAL_CONFIGS_LIST_FAIL";

export const GET_ZONAL_CONFIG_CHANNEL_INIT = "GET_ZONAL_CONFIG_CHANNEL_INIT";
export const GET_ZONAL_CONFIG_CHANNEL_SUCCESS =
  "ET_ZONAL_CONFIG_CHANNEL_SUCCESS";
export const GET_ZONAL_CONFIG_CHANNEL_FAIL = "ET_ZONAL_CONFIG_CHANNEL_FAIL";

export const ZONAL_CONFIG_UPLOAD_INIT = "ZONAL_CONFIG_UPLOAD_INIT";
export const ZONAL_CONFIG_UPLOAD_SUCCESS = "ZONAL_CONFIG_UPLOAD_SUCCESS";
export const ZONAL_CONFIG_UPLOAD_FAIL = "ZONAL_CONFIG_UPLOAD_FAIL";

export const CREATE_ZONAL_CONFIG_INIT = "CREATE_ZONAL_CONFIG_INIT";
export const CREATE_ZONAL_CONFIG_SUCCESS = "CREATE_ZONAL_CONFIG_SUCCESS";
export const CREATE_ZONAL_CONFIG_FAIL = "CREATE_ZONAL_CONFIG_FAIL";

export const UPDATE_ZONAL_CONFIG_INIT = "UPDATE_ZONAL_CONFIG_INIT";
export const UPDATE_ZONAL_CONFIG_SUCCESS = "UPDATE_ZONAL_CONFIG_SUCCESS";
export const UPDATE_ZONAL_CONFIG_FAIL = "UPDATE_ZONAL_CONFIG_FAIL";
export const CLEAR_ZONAL_CONFIG_DETAILS = "CLEAR_ZONAL_CONFIG_DETAILS";

export const GET_ZONAL_CONFIG_WAREHOUSE_INIT =
  "GET_ZONAL_CONFIG_WAREHOUSE_INIT";
export const GET_ZONAL_CONFIG_WAREHOUSE_SUCCESS =
  "GET_ZONAL_CONFIG_WAREHOUSE_SUCCESS";
export const GET_ZONAL_CONFIG_WAREHOUSE_FAIL =
  "GET_ZONAL_CONFIG_WAREHOUSE_FAIL";

export const GET_ZONAL_CONFIG_CHILD_ZONES_INIT =
  "GET_ZONAL_CONFIG_CHILD_ZONES_INIT";
export const GET_ZONAL_CONFIG_CHILD_ZONES_SUCCESS =
  "GET_ZONAL_CONFIG_CHILD_ZONES_SUCCESS";
export const GET_ZONAL_CONFIG_CHILD_ZONES_FAIL =
  "GET_ZONAL_CONFIG_CHILD_ZONES_FAIL";

export const GET_ZONAL_CONFIG_TOWNS_INIT = "GET_ZONAL_CONFIG_TOWNS_INIT";
export const GET_ZONAL_CONFIG_TOWNS_SUCCESS = "GET_ZONAL_CONFIG_TOWNS_SUCCESS";
export const GET_ZONAL_CONFIG_TOWNS_FAIL = "GET_ZONAL_CONFIG_TOWNS_FAIL";

export const GET_ZONAL_CONFIG_WAREHOUSE_NAME_INIT =
  "GET_ZONAL_CONFIG_WAREHOUSE_NAME_INIT";
export const GET_ZONAL_CONFIG_WAREHOUSE_NAME_SUCCESS =
  "GET_ZONAL_CONFIG_WAREHOUSE_NAME_SUCCESS";
export const GET_ZONAL_CONFIG_WAREHOUSE_NAME_FAIL =
  "GET_ZONAL_CONFIG_WAREHOUSE_NAME_FAIL";

export const GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_INIT =
  "GET_ZONAL_CONFIG_WAREHOUSE_LIST_INIT";
export const GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_SUCCESS =
  "GET_ZONAL_CONFIG_WAREHOUSE_LIST_SUCCESS";
export const GET_ZONAL_CONFIG_WAREHOUSE_LIST_WITH_STORAGE_BLOCKS_FAIL =
  "GET_ZONAL_CONFIG_WAREHOUSE_LIST_STORAGE_BLOCK_FAIL";

export const GET_PROMO_CITY_LEVEL_DETAILS_INIT =
  "GET_PROMO_CITY_LEVEL_DETAILS_INIT";
export const GET_PROMO_CITY_LEVEL_DETAILS_SUCCESS =
  "GET_PROMO_CITY_LEVEL_DETAILS_SUCCESS";
export const GET_PROMO_CITY_LEVEL_DETAILS_FAIL =
  "GET_PROMO_CITY_LEVEL_DETAILS_FAIL";
export const CLEAR_PROMO_CITY_LEVEL_DETAILS = "CLEAR_PROMO_CITY_LEVEL_DETAILS";

export const GET_PROMO_CITY_LEVEL_BY_TYPE_INIT =
  "GET_PROMO_CITY_LEVEL_BY_TYPE_INIT";
export const GET_PROMO_CITY_LEVEL_BY_TYPE_SUCCESS =
  "GET_PROMO_CITY_LEVEL_BY_TYPE_SUCCESS";
export const GET_PROMO_CITY_LEVEL_BY_TYPE_FAIL =
  "GET_PROMO_CITY_LEVEL_BY_TYPE_FAIL";

export const UPDATE_PROMO_CITY_LEVEL_STATUS_INIT =
  "UPDATE_PROMO_CITY_LEVEL_STATUS_INIT";
export const UPDATE_PROMO_CITY_LEVEL_STATUS_SUCCESS =
  "UPDATE_PROMO_CITY_LEVEL_STATUS_SUCCESS";
export const UPDATE_PROMO_CITY_LEVEL_STATUS_FAIL =
  "UPDATE_PROMO_CITY_LEVEL_STATUS_FAIL";

export const UPDATE_PROMO_CITY_LEVEL_INIT = "UPDATE_PROMO_CITY_LEVEL_INIT";
export const UPDATE_PROMO_CITY_LEVEL_SUCCESS =
  "UPDATE_PROMO_CITY_LEVEL_SUCCESS";
export const UPDATE_PROMO_CITY_LEVEL_FAIL = "UPDATE_PROMO_CITY_LEVEL_FAIL";

export const GET_PROMOS_CITY_LEVEL_FOR_ORDER_INIT =
  "GET_PROMOS_CITY_LEVEL_FOR_ORDER_INIT";
export const GET_PROMOS_CITY_LEVEL_FOR_ORDER_SUCCESS =
  "GET_PROMOS_CITY_LEVEL_FOR_ORDER_SUCCESS";
export const GET_PROMOS_CITY_LEVEL_FOR_ORDER_FAIL =
  "GET_PROMOS_CITY_LEVEL_FOR_ORDER_FAIL";

export const GET_UC_BY_CITY_ID_INIT = "GET_UC_BY_CITY_ID_INIT";
export const GET_UC_BY_CITY_ID_SUCCESS = "GET_UC_BY_CITY_ID_SUCCESS";
export const GET_UC_BY_CITY_ID_FAIL = "GET_UC_BY_CITY_ID_FAIL";

export const UPLOAD_USER_LEVEL_PROMO_CSV_INIT = "UPLOAD_USER_LEVEL_PROMO_INIT";
export const UPLOAD_USER_LEVEL_PROMO_CSV_SUCCESS =
  "UPLOAD_USER_LEVEL_PROMO_SUCCESS";
export const UPLOAD_USER_LEVEL_PROMO_CSV_FAIL = "UPLOAD_USER_LEVEL_PROMO_FAIL";

export const START_WAREHOUSE_SHIFT_INIT = "START_WAREHOUSE_SHIFT_INIT";
export const START_WAREHOUSE_SHIFT_SUCCESS = "START_WAREHOUSE_SHIFT_SUCCESS";
export const START_WAREHOUSE_SHIFT_FAIL = "START_WAREHOUSE_SHIFT_FAIL";

export const END_WAREHOUSE_SHIFT_INIT = "END_WAREHOUSE_SHIFT_INIT";
export const END_WAREHOUSE_SHIFT_SUCCESS = "END_WAREHOUSE_SHIFT_SUCCESS";
export const END_WAREHOUSE_SHIFT_FAIL = "END_WAREHOUSE_SHIFT_FAIL";

export const UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_INIT =
  "UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_INIT";
export const UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_SUCCESS =
  "UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_SUCCESS";
export const UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_FAIL =
  "UPLOAD_TOUR_FOR_WAREHOUSE_SHIFT_FAIL";

export const GET_STORE_TYPE_INIT = "GET_STORE_TYPE_INIT";
export const GET_STORE_TYPE_SUCCESS = "GET_STORE_TYPE_SUCCESS";
export const GET_STORE_TYPE_FAIL = "GET_STORE_TYPE_FAIL";

export const FETCH_CUSTOMER_CONFIG_INIT = "FETCH_CUSTOMER_CONFIG_INIT";
export const FETCH_CUSTOMER_CONFIG_SUCCESS = "FETCH_CUSTOMER_CONFIG_SUCCESS";
export const FETCH_CUSTOMER_CONFIG_FAIL = "FETCH_CUSTOMER_CONFIG_FAIL";

export const GET_CUSTOMER_ZONE_INIT = "GET_CUSTOMER_ZONE_INIT";
export const GET_CUSTOMER_ZONE_SUCCESS = "GET_CUSTOMER_ZONE_SUCCESS";
export const GET_CUSTOMER_ZONE_FAIL = "GET_CUSTOMER_ZONE_FAIL";

export const CREATE_CAMPAIGN_INIT = "CREATE_CAMPAIGN_INIT";
export const CREATE_CAMPAIGN_SUCCESS = "CREATE_CAMPAIGN_SUCCESS";
export const CREATE_CAMPAIGN_FAIL = "CREATE_CAMPAIGN_FAIL";

export const GET_CAMPAIGNS_INIT = "GET_CAMPAIGNS_INIT";
export const GET_CAMPAIGNS_SUCCESS = "GET_CAMPAIGNS_SUCCESS";
export const GET_CAMPAIGNS_FAIL = "GET_CAMPAIGNS_FAIL";

export const UPDATE_CAMPAIGN_INIT = "UPDATE_CAMPAIGN_INIT";
export const UPDATE_CAMPAIGN_SUCCESS = "UPDATE_CAMPAIGN_SUCCESS";
export const UPDATE_CAMPAIGN_FAIL = "UPDATE_CAMPAIGN_FAIL";

export const UPDATE_PASSWORD_INIT = "UPDATE_PASSWORD_INIT";
export const UPDATE_PASSWORD_SUCCESS = "UPDATE_PASSWORD_SUCCESS";
export const UPDATE_PASSWORD_FAIL = "UPDATE_PASSWORD_FAIL";

export const GET_CNIC_VERIFICATION_DATA_INIT =
  "GET_CNIC_VERIFICATION_DATA_INIT";
export const GET_CNIC_VERIFICATION_DATA_SUCCESS =
  "GET_CNIC_VERIFICATION_DATA_SUCCESS";
export const GET_CNIC_VERIFICATION_DATA_FAIL =
  "GET_CNIC_VERIFICATION_DATA_FAIL";

export const VERIFY_CNIC_DATA_INIT = "VERIFY_CNIC_DATA_INIT";
export const VERIFY_CNIC_DATA_SUCCESS = "VERIFY_CNIC_DATA_SUCCESS";
export const VERIFY_CNIC_DATA_FAIL = "VERIFY_CNIC_DATA_FAIL";

// Delivery date

// Init, success, failure state for fetch delivery date warehouse config
export const GET_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT =
  "GET_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT";
export const GET_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS =
  "GET_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS";
export const GET_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL =
  "GET_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL";

// Init, success, failure state for delivery date warehouses
export const GET_DELIVERY_DATE_WAREHOUSE_INIT =
  "GET_DELIVERY_DATE_WAREHOUSE_INIT";
export const GET_DELIVERY_DATE_WAREHOUSE_SUCCESS =
  "GET_DELIVERY_DATE_WAREHOUSE_SUCCESS";
export const GET_DELIVERY_DATE_WAREHOUSE_FAIL =
  "GET_DELIVERY_DATE_WAREHOUSE_FAIL";

// Init, success, failure state for create / update delivery date warehouses
export const CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT =
  "CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT";
export const CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS =
  "CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS";
export const CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL =
  "CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL";

// Init, success, failure state for paiya types
export const GET_PAIYA_TYPES_INIT = "GET_PAIYA_TYPES_INIT";
export const GET_PAIYA_TYPES_SUCCESS = "GET_PAIYA_TYPES_SUCCESS";
export const GET_PAIYA_TYPES_FAIL = "GET_PAIYA_TYPES_FAIL";

// Init, success, failure state for paiya config
export const GET_PAIYA_CONFIG_INIT = "GET_PAIYA_CONFIG_INIT";
export const GET_PAIYA_CONFIG_SUCCESS = "GET_PAIYA_CONFIG_SUCCESS";
export const GET_PAIYA_CONFIG_FAIL = "GET_PAIYA_CONFIG_FAIL";

// Init, success, failure state for create paiya config
export const CREATE_PAIYA_STORE_CONFIG_INIT = "CREATE_PAIYA_STORE_CONFIG_INIT";
export const CREATE_PAIYA_STORE_CONFIG_SUCCESS =
  "CREATE_PAIYA_STORE_CONFIG_SUCCESS";
export const CREATE_PAIYA_STORE_CONFIG_FAIL = "CREATE_PAIYA_STORE_CONFIG_FAIL";

// Init, success, failure state for create paiya config
export const CREATE_PAIYA_GIFT_CONFIG_INIT = "CREATE_PAIYA_GIFT_CONFIG_INIT";
export const CREATE_PAIYA_GIFT_CONFIG_SUCCESS =
  "CREATE_PAIYA_GIFT_CONFIG_SUCCESS";
export const CREATE_PAIYA_GIFT_CONFIG_FAIL = "CREATE_PAIYA_GIFT_CONFIG_FAIL";

// Init, success, failure state for create paiya config
export const CREATE_PAIYA_MOV_STATUS_CONFIG_INIT =
  "CREATE_PAIYA_MOV_STATUS_CONFIG_INIT";
export const CREATE_PAIYA_MOV_STATUS_CONFIG_SUCCESS =
  "CREATE_PAIYA_MOV_STATUS_CONFIG_SUCCESS";
export const CREATE_PAIYA_MOV_STATUS_CONFIG_FAIL =
  "CREATE_PAIYA_MOV_STATUS_CONFIG_FAIL";

export const CREATE_UPDATE_METRICS_INIT = "CREATE_UPDATE_METRICS_INIT";
export const CREATE_UPDATE_METRICS_SUCCESS = "CREATE_UPDATE_METRICS_SUCCESS";
export const CREATE_UPDATE_METRICS_FAIL = "CREATE_UPDATE_METRICS_FAIL";

export const GET_METRICS_DETAILS_INIT = "GET_METRICS_DETAILS_INIT";
export const GET_METRICS_DETAILS_SUCCESS = "GET_METRICS_DETAILS_SUCCESS";
export const GET_METRICS_DETAILS_FAIL = "GET_METRICS_DETAILS_FAIL";

export const GET_ALL_CORE_METRICS_INIT = "GET_ALL_CORE_METRICS_INIT";
export const GET_ALL_CORE_METRICS_SUCCESS = "GET_ALL_CORE_METRICS_SUCCESS";
export const GET_ALL_CORE_METRICS_FAIL = "GET_ALL_CORE_METRICS_FAIL";

export const GET_CATEGORIES_FOR_METRICS_INIT =
  "GET_CATEGORIES_FOR_METRICS_INIT";
export const GET_CATEGORIES_FOR_METRICS_SUCCESS =
  "GET_CATEGORIES_FOR_METRICS_SUCCESS";
export const GET_CATEGORIES_FOR_METRICS_FAIL =
  "GET_CATEGORIES_FOR_METRICS_FAIL";

export const METRICS_UPLOAD_INIT = "METRICS_UPLOAD_INIT";
export const METRICS_UPLOAD_SUCCESS = "METRICS_UPLOAD_SUCCESS";
export const METRICS_UPLOAD_FAIL = "METRICS_UPLOAD_FAIL";

export const WAREHOUSE_STAFF_LISTING_INIT = "WAREHOUSE_STAFF_LISTING_INIT";
export const WAREHOUSE_STAFF_LISTING_SUCCESS =
  "WAREHOUSE_STAFF_LISTING_SUCCESS";
export const WAREHOUSE_STAFF_LISTING_FAIL = "WAREHOUSE_STAFF_LISTING_FAIL";

export const GET_WAREHOUSE_STAFF_USER_DETAILS_INIT =
  "GET_WAREHOUSE_STAFF_USER_DETAILS_INIT";
export const GET_WAREHOUSE_STAFF_USER_DETAILS_SUCCESS =
  "GET_WAREHOUSE_STAFF_USER_DETAILS_SUCCESS";
export const GET_WAREHOUSE_STAFF_USER_DETAILS_FAIL =
  "GET_WAREHOUSE_STAFF_USER_DETAILS_FAIL";

export const GET_ALL_WAREHOUSES_INIT = "GET_ALL_WAREHOUSES_INIT";
export const GET_ALL_WAREHOUSES_SUCCESS = "GET_ALL_WAREHOUSES_SUCCESS";
export const GET_ALL_WAREHOUSES_FAIL = "GET_ALL_WAREHOUSES_FAIL";

export const GET_ALL_JOB_TYPES_INIT = "GET_ALL_JOB_TYPES_INIT";
export const GET_ALL_JOB_TYPES_SUCCESS = "GET_ALL_JOB_TYPES_SUCCESS";
export const GET_ALL_JOB_TYPES_FAIL = "GET_ALL_JOB_TYPES_FAIL";

export const CREATE_STAFF_INIT = "CREATE_STAFF_INIT";
export const CREATE_STAFF_SUCCESS = "CREATE_STAFF_SUCCESS";
export const CREATE_STAFF_FAIL = "CREATE_STAFF_FAIL";

export const UPDATE_STAFF_INIT = "UPDATE_STAFF_INIT";
export const UPDATE_STAFF_SUCCESS = "UPDATE_STAFF_SUCCESS";
export const UPDATE_STAFF_FAIL = "UPDATE_STAFF_FAIL";

export const GET_NEWSFEED_LIST_INIT = "GET_NEWSFEED_LIST_INIT";
export const GET_NEWSFEED_LIST_SUCCESS = "GET_NEWSFEED_LIST_SUCCESS";
export const GET_NEWSFEED_LIST_FAIL = "GET_NEWSFEED_LIST_FAIL";

export const CREATE_NEWSFEED_INIT = "CREATE_NEWSFEED_INIT";
export const CREATE_NEWSFEED_SUCCESS = "CREATE_NEWSFEED_SUCCESS";
export const CREATE_NEWSFEED_FAIL = "CREATE_NEWSFEED_FAIL";

export const UPDATE_NEWSFEED_INIT = "UPDATE_NEWSFEED_INIT";
export const UPDATE_NEWSFEED_SUCCESS = "UPDATE_NEWSFEED_SUCCESS";
export const UPDATE_NEWSFEED_FAIL = "UPDATE_NEWSFEED_FAIL";

export const UPDATE_DELIVERY_DATE_IN_LIVEOPS_SUCCESS =
  "UPDATE_DELIVERY_DATE_IN_LIVEOPS_SUCCESS";
export const UPDATE_DELIVERY_DATE_IN_LIVEOPS_FAIL =
  "UPDATE_DELIVERY_DATE_IN_LIVEOPS_FAIL";
export const UPDATE_DELIVERY_DATE_IN_LIVEOPS_INIT =
  "UPDATE_DELIVERY_DATE_IN_LIVEOPS_INIT";

export const AGENT_CHATWOOT_ASSIGNMENT_SUCCESS =
  "AGENT_CHATWOOT_ASSIGNMENT_SUCCESS";
export const AGENT_CHATWOOT_ASSIGNMENT_FAIL = "AGENT_CHATWOOT_ASSIGNMENT_FAIL";
export const AGENT_CHATWOOT_ASSIGNEMNT_INIT = "AGENT_CHATWOOT_ASSIGNEMNT_INIT";
export const AGENT_STORE_ASSIGNMENT_SUCCESS = "AGENT_STORE_ASSIGNMENT_SUCCESS";
export const AGENT_STORE_ASSIGNMENT_FAIL = "AGENT_STORE_ASSIGNMENT_FAIL";
export const AGENT_STORE_ASSIGNMENT_INIT = "AGENT_STIRE_ASSIGNMENT_INIT";

export const FETCH_ALL_FILTERS_INIT = "FETCH_ALL_FILTERS_INIT";
export const FETCH_ALL_FILTERS_SUCCESS = "FETCH_ALL_FILTERS_SUCCESS";
export const FETCH_ALL_FILTERS_FAIL = "FETCH_ALL_FILTERS_FAIL";

export const CREATE_PAIYA_GIFT_INIT = "CREATE_PAIYA_GIFT_INIT";
export const CREATE_PAIYA_GIFT_SUCCESS = "CREATE_PAIYA_GIFT_SUCCESS";
export const CREATE_PAIYA_GIFT_FAIL = "CREATE_PAIYA_GIFT_FAIL";

export const FETCH_PAIYA_GIFT_INIT = "FETCH_PAIYA_GIFT_INIT";
export const FETCH_PAIYA_GIFT_SUCCESS = "FETCH_PAIYA_GIFT_SUCCESS";
export const FETCH_PAIYA_GIFT_FAIL = "FETCH_PAIYA_GIFT_FAIL";
export const CLEAR_PAIYA_GIFT_DETAILS = "CLEAR_PAIYA_GIFT_DETAILS";

export const CREATE_PROMO_BULK_INIT = "CREATE_PROMO_BULK_INIT";
export const CREATE_PROMO_BULK_SUCCESS = "CREATE_PROMO_BULK_SUCCESS";
export const CREATE_PROMO_BULK_FAIL = "CREATE_PROMO_BULK_FAIL";

export const DEACTIVATE_PROMO_BULK_INIT = "DEACTIVATE_PROMO_BULK_INIT";
export const DEACTIVATE_PROMO_BULK_SUCCESS = "DEACTIVATE_PROMO_BULK_SUCCESS";
export const DEACTIVATE_PROMO_BULK_FAIL = "DEACTIVATE_PROMO_BULK_FAIL";

export const GET_USERS_CREDIT_LIMIT_INIT = "GET_USERS_CREDIT_LIMIT_INIT";
export const GET_USERS_CREDIT_LIMIT_SUCCESS = "GET_USERS_CREDIT_LIMIT_SUCCESS";
export const GET_USERS_CREDIT_LIMIT_FAIL = "GET_USERS_CREDIT_LIMIT_FAIL";

export const GET_CREDIT_PAYMENT_PLANS_INIT = "GET_CREDIT_PAYMENT_PLANS_INIT";
export const GET_CREDIT_PAYMENT_PLANS_SUCCESS =
  "GET_CREDIT_PAYMENT_PLANS_SUCCESS";
export const GET_CREDIT_PAYMENT_PLANS_FAIL = "GET_CREDIT_PAYMENT_PLANS_FAIL";

export const CLEAR_CREDIT_LIMIT_AND_PLANS = "CLEAR_CREDIT_LIMIT_AND_PLANS";
